import Vue from 'vue';
import recipeTransformer from '../../transformers/recipe';
import store from '../../store';

const success = ({ data }) => {
  const recipe = recipeTransformer.fetch(data);
  store.dispatch('fetchAllRecipeProducts', recipe.products);
  return recipe;
};

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    const recipes = store.state.recipe.items.filter(p => (
      id.toString() === p.id.toString()
    ));

    if (recipes.length > 0) {
      return resolve(recipes[0]);
    }

    return Vue.$http.get(`/production/recipe/${id}`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/recipe/show.js